import {
    GETMAPPEDLISTFORADMIN_SUCCESS,
    GETMAPPEDLISTFORADMIN_FAILED,
    RESET_GETMAPPEDLISTFORADMIN,
    LOADING_GETMAPPEDLISTFORADMIN,
    NETWORK_ERROR_GETMAPPEDLISTFORADMIN
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetMappedListForAdmin = () => {
    return { type: RESET_GETMAPPEDLISTFORADMIN };
};

const getMappedListForAdmins = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETMAPPEDLISTFORADMIN });
    await adminServices
        .post("getmappedlistforadmin", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getMappedListForAdminsuccess(res.data));
                    break;
                default:
                    dispatch(getMappedListForAdminFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETMAPPEDLISTFORADMIN,
                payload: err
            });
        });
};
function getMappedListForAdminsuccess(data) {
    return {
        type: GETMAPPEDLISTFORADMIN_SUCCESS,
        payload: data
    };
}
function getMappedListForAdminFailed(data) {
    return {
        type: GETMAPPEDLISTFORADMIN_FAILED,
        payload: data
    };
}

export { resetGetMappedListForAdmin, getMappedListForAdmins };
